import { z } from 'zod';
export const emailSchema = z
    .string()
    .trim()
    .toLowerCase()
    .min(1, 'Ingresá tu email')
    .max(254)
    .pipe(z.email('Email inválido'));
export const passwordSchema = z
    .string()
    .min(8, 'La contraseña tiene que tener al menos 8 caracteres')
    .max(128, 'La contraseña es demasiado larga');
export const registerSchema = z.object({
    name: z.string().trim().min(2, 'Ingresá tu nombre').max(80),
    email: emailSchema,
    password: passwordSchema,
});
export const loginSchema = z.object({
    email: emailSchema,
    password: z.string().min(1, 'Ingresá tu contraseña').max(128),
});
//# sourceMappingURL=auth.js.map